export const OCPP_1_6_MESSAGES = {
  Authorize: 1001,
  BootNotification: 1002,
  ChangeConfiguration: 1014,
  ChargeLevelChange: 2028,
  ClearCache: 1025,
  ClearChargingProfile: 1010,
  ConfigurationChange: 2052,
  DataTransfer: 1020,
  DiagnosticsStatusNotification: 1023,
  DynamicLoadBalancing: 2026,
  EcoChargeScheduleRequest: 2000,
  EcoMode: 2001,
  FaultClear: 2016,
  FaultSet: 2007,
  FirmwareStatusNotification: 1013,
  GatewayLocalConnection: 2023,
  GatewayLocalConnectionStatus: 2024,
  GatewayTokenRefresh: 2025,
  GetCompositeSchedule: 1011,
  GetConfiguration: 1015,
  GetCustomConfigurations: 2019,
  GetDiagnostics: 1022,
  GetEcoMode: 2040,
  GetInventoryReport: 2008,
  GetLgcConfig: 2054,
  GetNetworkStatistics: 2050,
  GetPartnerConnectionStatus: 2047,
  GetPhaseInfo: 2039,
  GetSshConfig: 2036,
  GetVpnStatus: 2022,
  GlobalAuthConfig: 2004,
  GlobalAuthStatus: 2017,
  Heartbeat: 1000,
  InstallCertificate: 2030,
  InstallChargePointCertificate: 2031,
  InventoryReport: 2002,
  LgcSlots: 2038,
  LocalIntegrationSafeMode: 2029,
  MeterConfig: 2041,
  MeterConfirmation: 2044,
  MeterConnectionStatus: 2042,
  MeterDetectionStatus: 2043,
  MeterValues: 1006,
  MIDUploadStatus: 2014,
  NetworkConfig: 2003,
  NetworkStatistics: 2049,
  OffGridStatus: 2051,
  PartnerConnectionStatus: 2046,
  PartnerOcppConfig: 2045,
  PhaseInfo: 2005,
  RandomDelayStatus: 2033,
  RemoteStartTransaction: 1007,
  RemoteStopTransaction: 1008,
  Reset: 1017,
  ResetOrientation: 2034,
  ResetPartnerConnection: 2048,
  RetireCharger: 2010,
  SecurityEventNotification: 1024,
  SendLocalList: 1016,
  SetChargingProfile: 1009,
  SetCustomConfigurations: 2018,
  SetSshConfig: 2035,
  SetVpnConfig: 2021,
  SignatureInfo: 2013,
  SkipRandomDelay: 2032,
  StartTransaction: 1004,
  StatusNotification: 1003,
  StopTransaction: 1005,
  TimezoneInfo: 2015,
  TriggerMessage: 1018,
  UnlockConnector: 1026,
  UpdateFirmware: 1012,
  UpdateLgcConfig: 2053,
  WifiRssi: 2006,
  LocalDevices: 2080,
  LocalDevicesStatus: 2091,
  V2XChargingCtrlrMode: 2099,
  NotifyEVChargingNeeds: 2100,
  EnergyTransferDirection: 2101,
  GetEnergyTransferDirection: 2102,
  SetV2XReserveLevels: 2103,
  UpdateGridStatus: 2104,
  PCUTelemetry: 2105,
  MeterCollarTelemetry: 2106,
  GridProfile: 2107,
};

export const LABELS = {
  MESSAGE_TYPE: "Message Type",
  FEATURE: "Feature",
  ANY: "Any",
  ANY_FEATURE: "Any Feature",
  SEARCH_FEATURE_PLACEHOLDER: "Search features...",
  SEARCH_MESSAGE_PLACEHOLDER: "Search message...",
};

export const INPUT_HEIGHT = 40;
export const INPUT_MIN_WIDTH = 260;

export const COMMON_INPUT_STYLES = {
  minWidth: INPUT_MIN_WIDTH,
  "& .MuiInputBase-root": {
    height: INPUT_HEIGHT,
  },
};

export const FEATURE_OPTIONS = Object.keys(OCPP_1_6_MESSAGES || {});

export const ICON_SIZE = { width: 24, height: 24 };

export const MESSAGE_CONFIG = {
  cloudIncomingRequest: {
    source: "Device",
    msgType: "2",
    direction: "incoming",
    icon: "CloudIncomingIcon",
    fill: "#3B82F6",
    label: "Cloud Incoming Request",
  },
  cloudIncomingResponse: {
    source: "Device",
    msgType: "3",
    direction: "incoming",
    icon: "CloudIncomingIcon",
    fill: "#16A34A",
    label: "Cloud Incoming Response",
  },
  cloudIncomingError: {
    source: "Device",
    msgType: "4",
    direction: "incoming",
    icon: "CloudIncomingIcon",
    fill: "#DC2626",
    label: "Cloud Incoming Error",
  },

  cloudOutgoingRequest: {
    source: "Cloud",
    msgType: "2",
    direction: "outgoing",
    icon: "CloudOutgoingIcon",
    fill: "#3B82F6",
    label: "Cloud Outgoing Request",
  },
  cloudOutgoingResponse: {
    source: "Cloud",
    msgType: "3",
    direction: "outgoing",
    icon: "CloudOutgoingIcon",
    fill: "#16A34A",
    label: "Cloud Outgoing Response",
  },
  cloudOutgoingError: {
    source: "Cloud",
    msgType: "4",
    direction: "outgoing",
    icon: "CloudOutgoingIcon",
    fill: "#DC2626",
    label: "Cloud Outgoing Error",
  },
};
